import React from 'react';
import './KpiTile.css';

const KpiRow: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="kpi-row">{children}</div>
);

export default KpiRow;
